'use client';
import React, { useState, useEffect } from 'react';

export default function DriveXNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'Características', id: 'caracteristicas' },
    { label: 'Precios', id: 'pricing' },
    { label: 'Demo', id: 'demo' },
    { label: 'Contacto', id: 'contacto' },
  ];

  return (
    <>
      <nav
        className="dx-font fixed top-0 left-0 right-0 z-[100] transition-all duration-300"
        style={{
          background: scrolled ? 'rgba(17,17,17,0.95)' : 'transparent',
          backdropFilter: scrolled ? 'blur(12px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(200,16,46,0.12)' : '1px solid transparent',
        }}
      >
        <div className="max-w-7xl mx-auto px-6 h-[72px] flex items-center justify-between">
          {/* Logo */}
          <div className="flex flex-col leading-none cursor-pointer" onClick={() => scrollTo('hero')}>
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 900, fontSize: '20px', color: '#FFFFFF', letterSpacing: '0.08em' }}>
              DriveX
            </span>
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '10px', color: '#888888', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
              by BT SaaS
            </span>
          </div>

          {/* Center links — desktop */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="transition-colors duration-200"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '12px', color: '#AAAAAA', letterSpacing: '0.08em', textTransform: 'uppercase', background: 'none', border: 'none', cursor: 'pointer' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#FFFFFF')}
                onMouseLeave={e => (e.currentTarget.style.color = '#AAAAAA')}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Right buttons */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="/admin/login"
              className="transition-colors duration-200"
              style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '12px', color: '#AAAAAA', border: '1px solid #AAAAAA', padding: '8px 16px', borderRadius: '4px', textDecoration: 'none' }}
              onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#FFFFFF'; (e.currentTarget as HTMLElement).style.borderColor = '#FFFFFF'; }}
              onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = '#AAAAAA'; (e.currentTarget as HTMLElement).style.borderColor = '#AAAAAA'; }}
            >
              Iniciar sesión
            </a>
            <button
              onClick={() => scrollTo('pricing')}
              style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '12px', color: '#FFFFFF', background: '#C8102E', padding: '8px 16px', borderRadius: '4px', border: 'none', cursor: 'pointer' }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.background = '#9B0D22')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.background = '#C8102E')}
            >
              Empezar gratis
            </button>
          </div>

          {/* Hamburger */}
          <button
            className="md:hidden flex flex-col gap-[5px] p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            <span className="block w-5 h-[2px] bg-white transition-all" style={{ transform: mobileOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
            <span className="block w-5 h-[2px] bg-white transition-all" style={{ opacity: mobileOpen ? 0 : 1 }} />
            <span className="block w-5 h-[2px] bg-white transition-all" style={{ transform: mobileOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
          </button>
        </div>

        {/* Mobile dropdown */}
        {mobileOpen && (
          <div style={{ background: '#111111', borderTop: '1px solid rgba(200,16,46,0.12)' }} className="md:hidden px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="text-left"
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '13px', color: '#AAAAAA', letterSpacing: '0.08em', textTransform: 'uppercase', background: 'none', border: 'none', cursor: 'pointer' }}
              >
                {link.label}
              </button>
            ))}
            <div className="flex flex-col gap-2 pt-2" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
              <a href="/admin/login" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '13px', color: '#AAAAAA', textDecoration: 'none' }}>
                Iniciar sesión
              </a>
              <button
                onClick={() => scrollTo('pricing')}
                style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '13px', color: '#FFFFFF', background: '#C8102E', padding: '10px 16px', borderRadius: '4px', border: 'none', cursor: 'pointer', textAlign: 'left' }}
              >
                Empezar gratis
              </button>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}
